import { useEffect, useCallback } from "react";

export const useDelayedEffect = (effect: () => void, dependencies: unknown[], delay: number) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callback = useCallback(effect, dependencies);

  useEffect(() => {
    const timeout = setTimeout(callback, delay);
    return () => clearTimeout(timeout);
  }, [callback, delay]);
};
